:host {
  display: block;
  sportsline-company-logo {
    display: none;
  }
  @media (min-width: 768px) {
    sportsline-company-logo {
      display: inline-block;
    }
  }
}


.free-expert-pick-footer {
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.free-expert-pick-footer__text {
  flex: 1;
  color: var(--text-footer-color);

  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.2;

  @media screen and (min-width: 768px) {
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.2;
  }
}

sportsline-button {
  width: 100%;
  display: flex;
}

@media (min-width: 768px) {
  .free-expert-pick-footer {
    flex-direction: row;
  }
  sportsline-button {
    width: auto;
  }
}
